// extracted by mini-css-extract-plugin
export default {"note":"CareerUpdated_note__VB0OD"};